import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import FormatListBulletedSharpIcon from "@mui/icons-material/FormatListBulletedSharp";
import { Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

type Props = {
	setId?: (id: number) => void;
	url?: string;
	id?: number;
	edit: boolean;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: (event: React.MouseEvent) => void;
};

export const GridButtons = ({
	setId = () => {},
	url = "",
	id = -1,
	edit = true,
	setShowModal,
	showContextMenu,
}: Props) => {
	const navigate = useNavigate();

	return (
		<Box
			sx={{
				height: "100%",
				display: "flex",
				justifyContent: "flex-end",
				alignItems: "center",
				paddingRight: "8px",
			}}
		>
			<Box sx={{ display: "flex", gap: 0 }}>
				{edit && (
					<Button
						onClick={() => {
							setId(id);
							setShowModal("update");
							navigate(url);
						}}
						title="Edit"
						size="small"
						sx={{ minWidth: 32, padding: "4px 8px" }}
					>
						<EditIcon sx={{ fontSize: 18 }} color="primary" />
					</Button>
				)}
				<Button
					onClick={() => {
						setId(id);
						setShowModal("delete");
					}}
					title="Delete"
					size="small"
					sx={{ minWidth: 32, padding: "4px 8px" }}
				>
					<DeleteIcon sx={{ fontSize: 18 }} color="secondary" />
				</Button>
				<Button
					onClick={showContextMenu}
					title="Options"
					size="small"
					sx={{ minWidth: 32, padding: "4px 8px" }}
				>
					<FormatListBulletedSharpIcon sx={{ fontSize: 18 }} color="action" />
				</Button>
			</Box>
		</Box>
	);
};
